import React, { useState } from 'react';
import MessageInput from './MessageInput';
import MessageBubble from './MessageBubble';
import { translateToEnglish, translateToPersian } from '../utils/translator';
import { sanitizeText } from '../utils/sanitizeText';
import { rewriteTextLLM } from '../utils/rewriteText';

function ChatBox({ darkMode }) {
  const [messages, setMessages] = useState([]);
  const [status, setStatus] = useState('');

  const normalizeText = (text) => {
    if (!text) return '';
  
    return text
      .replace(/\u200c/g, '') // حذف نیم فاصله‌ها (Zero-Width Non-Joiner)
      .replace(/,/g, '،') // کاما انگلیسی به ویرگول فارسی
      .replace(/\s*([.,!?:;،؛؟])\s*/g, '$1 ') // حذف فاصله قبل، اضافه فاصله بعد
      .replace(/\s+/g, ' ') // تبدیل چند فاصله به یک فاصله
      .trim(); // حذف فاصله‌های ابتدا و انتها
  };  
  
  const applyReplacements = (text) => {
    const settingsRaw = localStorage.getItem('groqSettings') || '{}';
    const settings = JSON.parse(settingsRaw);
    const replacements = settings.replacements || [];
  
    // اول متن را نرمال کن
    let result = normalizeText(text);
  
    replacements.forEach(({ find, replace }) => {
      if (find && replace) {
        const cleanFind = find.trim();
        result = result.split(cleanFind).join(replace);
      }
    });
  
    return result;
  };  

  const handleSend = async (textOriginal) => {
    if (!textOriginal.trim()) return;

    // نمایش پیام کاربر
    const userMsg = { type: 'user', text: textOriginal };
    setMessages(prev => [...prev, userMsg]);

    // فیلتر ورودی
    const filtered = sanitizeText(textOriginal);
    if (!filtered) return;

    try {
      setStatus('در حال ترجمه به انگلیسی...');
      const translatedToEnglish = await translateToEnglish(filtered);

      setStatus('در حال بازنویسی متن...');
      const rewrittenEnglish = await rewriteTextLLM(translatedToEnglish);

      // فیلتر خروجی LLM
      const cleanedRewritten = sanitizeText(rewrittenEnglish);

      setStatus('در حال ترجمه به فارسی...');
      let rewrittenPersian = await translateToPersian(cleanedRewritten);

      // جایگزینی کلمات دلخواه کاربر
      rewrittenPersian = applyReplacements(rewrittenPersian);

      // نمایش پیام سیستم
      const botMsg = { type: 'bot', text: rewrittenPersian };
      setMessages(prev => [...prev, botMsg]);

    } catch (error) {
      console.error('Error processing message:', error);
      setMessages(prev => [...prev, { type: 'bot', text: '[خطا در پردازش]' }]);
    } finally {
      setStatus('');
    }
  };

  return (
    <div
      className="border rounded p-3"
      style={{
        background: darkMode ? '#1e1e1e' : '#f9f9f9',
        minHeight: '500px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* وضعیت پردازش */}
      <div className="mb-2 text-center" style={{ minHeight: '24px', color: darkMode ? '#ccc' : '#555' }}>
        {status && <small>{status}</small>}
      </div>

      {/* لیست پیام‌ها */}
      <div
        className="mb-3 flex-grow-1"
        style={{ maxHeight: '400px', overflowY: 'auto', padding: '8px', background: darkMode ? '#2c2c2c' : '#ffffff', borderRadius: '8px' }}
      >
        {messages.map((msg, idx) => (
          <MessageBubble key={idx} message={msg} darkMode={darkMode} />
        ))}
      </div>

      {/* ورودی پیام */}
      <MessageInput onSend={handleSend} />
    </div>
  );
}

export default ChatBox;
